import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'qpoint-toolbar-split-button-action',
  template: '',
  standalone: true
})
export class QPointToolbarSplitButtonActionComponent {
  @Input() text: string;
  @Input() disabled: boolean;
  @Output() actionClick = new EventEmitter<void>();
}
